export default {
    "defaultGameSlug": "book"
}
